module.exports = __webpack_public_path__ + "static/OG_Who-we-work-68b15228308d8e66e8a85cb1cf299e1b.png";